module.exports = {"blocks":[{"type":"sections/pricing/pricing_hero","prefix":"pricing_hero"},{"type":"sections/aside","prefix":"pricing_aside"}],"aside":{"prefix":"pricing","bottom":"300","items":[{"target":"quoting","offset":"-114"},{"target":"headline","offset":"-114"},{"target":"pricing_table","offset":"-114"}],"blocks":[{"type":"pricing_headline","prefix":"pricing_headline"},{"type":"pricing_image","prefix":"pricing_table"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/tw/setting/pricing/setting.json
// module id = 744
// module chunks = 0 1 2 3 4 5